import {
    Box, Button, Card, CardActionArea, CardMedia, Icon,
    Paper, Tooltip, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses, Autocomplete,
    CircularProgress,
    TextField, styled,
    Checkbox as MuiCheckBox,
    FormControl,
    FormControlLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { IDadosFranquiaJogador, IDadosFranquiaMultasAnual, IDadosTitulosJogador, IDetalheFranquia, IListagemJogadorFranquia } from "../../shered/services/api/jogador/JogadorService";
import { ILstDrop, TipoSalario, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { FranquiaService, IDadosResumoPicksAno } from "../../shered/services/api/franquia/FranquiaService";
import { UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DonwloadDadosFranquia } from "../../shered/components/arquivos/DonwloadTimeFranquia";



export const ListagemDeFranquias: React.FC = () => {
    const theme = useTheme();
    const refTab = useRef<any>(null);
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoSelecionada, setCodigoSelecionada] = useState(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [searchParamsJogadores, SetSearchParamsJogadores] = useSearchParams();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const [removeLoading, setRemoveLoading] = useState(false);
    const [rowsFranquias, setRowsFranquias] = useState<IDetalheFranquia[]>([]);
    const [totalCountJogadores, setTotalCountJogadores] = useState(0);
    const [estatisticasRows, setEstatisticasRows] = useState<IDadosFranquiaJogador[]>([]);
    const [franquiaMultasAnualRows, setFranquiaMultasAnualRows] = useState<IDadosFranquiaMultasAnual>();
    const [isLoading, setIsLoading] = useState(true);
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    //const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([]);
    const [franquia, setFranquia] = useState<IDetalheFranquia>();
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [irregularidades, setIrregularidades] = useState<any[]>([]);
    //newConferencia.png  newDivisao.png  newLiga.png
    const [imagemTrofelConferencia] = useState<any | null>("../../newConferencia.png");
    const [imagemTrofelDivisao] = useState<any | null>("../../newDivisao.png");
    const [imagemTrofelLiga] = useState<any | null>("../../newLiga.png");
    const [imagemTrofelCopinha] = useState<any | null>("../../../newCopinha.png");
    const [nomeLiga, setNomeLiga] = useState("");
    const [showTitulos, setShowTitulos] = useState(false);
    const [usuarioComissario, setUsuarioComissario] = useState(false);

    const [ano1, setAno1] = useState("");
    const [ano2, setAno2] = useState("");
    const [ano3, setAno3] = useState("");
    const [ano4, setAno4] = useState("");
    const [ano5, setAno5] = useState("");
    const [resumo_Picks_Ano1, setResumo_Picks_Ano1] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano2, setResumo_Picks_Ano2] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano3, setResumo_Picks_Ano3] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano4, setResumo_Picks_Ano4] = useState<IDadosResumoPicksAno[]>([]);
    const [resumo_Picks_Ano5, setResumo_Picks_Ano5] = useState<IDadosResumoPicksAno[]>([]);
    const [nome_Franquia, setNome_Franquia] = useState("");
    const [nome_Usuario, setNome_Usuario] = useState("");
    const [valor_CAP, setValor_CAP] = useState("");
    const [valor_Draft, setValor_Draft] = useState("");
    const [titulosConferencia, setTitulosConferencia] = useState<IDadosTitulosJogador[]>([]);
    const [titulosDivisao, setTitulosDivisao] = useState<IDadosTitulosJogador[]>([]);
    const [titulosLiga, setTitulosLiga] = useState<IDadosTitulosJogador[]>([]);
    const [titulosCopinha, setTitulosCopinha] = useState<IDadosTitulosJogador[]>([]);
    const [qtd_Slots, setQtd_Slots] = useState("");
    const [opcoesAutoCompleteUsuarioGM, setOpcoesAutoCompleteUsuarioGM] = useState<ILstDrop[]>([])
    const [selectedIdCompleteGM, setSelectedIdCompleteGM] = useState<number | undefined>(0);
    const [showCampoEdicaoGm, setShowCampoEdicaoGm] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [showDadosFranquia, setShowDadosFranquia] = useState(false);
    const [chkSerComissario, setChkSerComissario] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadas(true, 0)
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
                UsuarioService.getAll()
                    .then((result) => {
                        setIsLoading(false);
                        const lst = result.data.dado;
                        setOpcoesAutoCompleteUsuarioGM(lst.map(p => ({ codigo: p.codigo, label: p.nome + " - " + p.email })));
                    })
                    .catch((errors) => {

                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da Liga! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
                FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        setRemoveLoading(true);
                        setIsLoading(false);
                        const lst = result.dado;
                        setRowsFranquias(lst);
                        let comissario = lst.find(f => f.codigo_Usuario === user.codUsuario)?.comissario;
                        setUsuarioComissario(comissario === undefined ? false : comissario)
                        setShowDadosFranquia(false);
                        carregarCabecalhoTemporadas(Number(codigoLiga));
                    })
                    .catch((errors) => {
                        setIsLoading(false);
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });
                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });
            })
        }
    }, []);


    const carregarCabecalhoTemporadas = (codigo: number) => {
        UtilidadeService.getDescricaoTemporadoPorCodigoLiga(codigo)
            .then((result) => {
                setIsLoading(false);
                const tmps = result.dado;
                setAno1(tmps.descricao_Ano1);
                setAno2(tmps.descricao_Ano2);
                setAno3(tmps.descricao_Ano3);
                setAno4(tmps.descricao_Ano4);
                setAno5(tmps.descricao_Ano5);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }

    }

    // const handleDelete = (id: number) => {
    //     if (window.confirm("Realmente deseja apagar?")) {
    //         FranquiaService.deleteById(id)
    //             .then((result) => {
    //                 setIsLoading(false);
    //                 setRowsJogadores(oldRows => [
    //                     ...oldRows.filter(oldRow => oldRow.codigo !== id),
    //                 ]);
    //                 setShowModalMensagem(true);
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "success",
    //                     mensagem: "Registro excluido com sucesso!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //             }).catch((errors) => {
    //                 setShowModalMensagem(true);
    //                 if (errors.response.status === 401) {
    //                     setDadosModalMensagem({
    //                         acao: true,
    //                         label: "",
    //                         tipo: "info",
    //                         mensagem: "Sessão expirada!",
    //                         display: "none",
    //                         titulo: "Atenção"
    //                     });
    //                     logout();
    //                     setRedirecionar("0");
    //                     return;
    //                 }
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: errors.response.data.mensagem,
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //             })
    //     }
    // }

    const handleCarregarDadosMultas = (codigoFranquia: number) => {
        setShowModalEvent(true);
        setDadosModalEvent({
            acao: true,
            label: "Multas",
            tipo: "info",
            mensagem: `Detalhes multas dos jogadores`,
            display: "none",
            titulo: "Atenção",
            evento: "multasJogador",
            info: {
                codigoFranquia: codigoFranquia,
                // mensagemAdicional: `Multas: ${valoresMultas}`,
                // style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });
    }

    const handleSelecionaJogadores = (codigoFranquia: number) => {
        setCodigoSelecionada(codigoFranquia);
        setTitulosConferencia([]);
        setTitulosDivisao([]);
        setTitulosLiga([]);
        setTitulosCopinha([]);
        setShowTitulos(false);
        FranquiaService.getByIdFranquia(codigoFranquia)
            .then((result) => {
                setIsLoading(false);
                let franquia = result.dado;
                setShowDadosFranquia(true);
                setFranquia(franquia);
                setShowImagemFranquia(franquia.caminho_Logo === null ? "../../semimagemescudo.png" : franquia.caminho_Logo);
                setNomeLiga(franquia.nome);
                setNome_Franquia(franquia.nome);
                setNome_Usuario(franquia.nome_Usuario);
                setValor_CAP(franquia.capacidade_Restante);
                setValor_Draft(franquia.capacidade_Draft);
                setQtd_Slots(franquia.espaco_Restante);

                setResumo_Picks_Ano1(franquia.resumo_Picks_Ano1);
                setResumo_Picks_Ano2(franquia.resumo_Picks_Ano2);
                setResumo_Picks_Ano3(franquia.resumo_Picks_Ano3);
                setResumo_Picks_Ano4(franquia.resumo_Picks_Ano4);
                setResumo_Picks_Ano5(franquia.resumo_Picks_Ano5);

                setIrregularidades(franquia.irregularidades);
                let titulos_conferencia: IDadosTitulosJogador[] = [];
                let titulos_divisao: IDadosTitulosJogador[] = [];
                let titulos_liga: IDadosTitulosJogador[] = [];
                let titulos_Copinha: IDadosTitulosJogador[] = [];
                if (franquia.franquia_Titulos.length > 0) {
                    setShowTitulos(true);
                    franquia.franquia_Titulos.forEach(f => {
                        if (f.codigo_Divisao !== null) {
                            titulos_divisao.push(f);
                        }
                        if (f.codigo_Conferencia !== null) {
                            titulos_conferencia.push(f);
                        }
                        if (f.codigo_Liga !== null) {
                            titulos_liga.push(f);
                        }
                        if (f.copinha) {
                            titulos_Copinha.push(f);
                        }
                    });
                }
                setTitulosConferencia(titulos_conferencia);
                setTitulosDivisao(titulos_divisao);
                setTitulosLiga(titulos_liga);
                setTitulosCopinha(titulos_Copinha);
                setEstatisticasRows(franquia.franquia_Jogador.length > 0 ? franquia.franquia_Jogador : []);
                setFranquiaMultasAnualRows(franquia.franquia_Multas_Anual);
                setTotalCountJogadores(franquia.franquia_Jogador.length > 0 ? franquia.franquia_Jogador.length : 0);


            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });

        // JogadorService.getAllPorFranquia(codigoFranquia)
        //     .then((result) => {
        //         setIsLoading(false);
        //         let resultado = result.dado;
        //         setRowsJogadores(resultado);
        //     }).catch((errors) => {
        //         setIsLoading(false);
        //         setShowModalMensagem(true);
        //         setRemoveLoading(true);

        //         if (errors.response.status === 401) {
        //             setDadosModalMensagem({
        //                 acao: true,
        //                 label: "",
        //                 tipo: "info",
        //                 mensagem: "Sessão expirada!",
        //                 display: "none",
        //                 titulo: "Atenção"
        //             });
        //             logout();
        //             setRedirecionar("0");
        //             return;
        //         }
        //         setDadosModalMensagem({
        //             acao: true,
        //             label: "",
        //             tipo: "error",
        //             mensagem: errors.response.data.mensagem,
        //             display: "none",
        //             titulo: "Atenção"
        //         });
        //         return;
        //     });
    }

    useEffect(() => {
        if (refTab.current !== null) {
            refTab.current.focus();
        }
    })

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 11 : 14,
            padding: UtilidadeService.isMobile() ? "4px" : "8px",

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 11 : 13,
            padding: "4px",
            fontFamily: "sans-serif",
            fontWeight: "bold",
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: UtilidadeService.isMobile() ? "8px 5px" : "16px 10px",
        },
    }));

    const handleAlterarGMFranquia = (exibir: boolean) => {
        setShowCampoEdicaoGm(exibir);
    }

    const handleSalvarGMFranquia = () => {
        setShowModalMensagem(false);
        //if (Number(selectedIdCompleteGM) > 0 && rowsFranquias.find(f => f.codigo_Usuario === selectedIdCompleteGM) === undefined) {

        setNome_Usuario(autoCompleteSelectedOptionGM?.label !== undefined
            ? autoCompleteSelectedOptionGM?.label.split("-")[0]
            : "");

        if (selectedIdCompleteGM === 0 || selectedIdCompleteGM === undefined) {
            setIsLoading(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o usuário!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        let dados: any = {
            codigo: codigoSelecionada,
            codigoUsuarioGM: selectedIdCompleteGM,
            comissario: chkSerComissario,
            codUsuModificacao: user.codUsuario,

        }

        FranquiaService.updateByIdGmFranquia(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "GM alterado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });
                setRedirecionar("0");
                setShowCampoEdicaoGm(false);
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
        // }
        // else {
        //     setIsLoading(false);
        //     setShowModalMensagem(true);
        //     setDadosModalMensagem({
        //         acao: true,
        //         label: "",
        //         tipo: "info",
        //         mensagem: "Usuário selecionado já está participando da liga!",
        //         display: "none",
        //         titulo: "Atenção"
        //     });
        //     setRedirecionar("");
        // }
    }

    const somatorio1 = estatisticasRows.map(({ salario_1 }) => Number(salario_1.toString())).reduce((sum, i) => sum + i, 0);
    const somatorio2 = estatisticasRows.map(({ salario_2 }) => Number(salario_2 != null ? salario_2.toString() : 0)).reduce((sum, i) => sum + i, 0);
    const somatorio3 = estatisticasRows.map(({ salario_3 }) => Number(salario_3 != null ? salario_3.toString() : 0)).reduce((sum, i) => sum + i, 0);
    const somatorio4 = estatisticasRows.map(({ salario_4 }) => Number(salario_4 != null ? salario_4.toString() : 0)).reduce((sum, i) => sum + i, 0);
    const somatorio5 = estatisticasRows.map(({ salario_5 }) => Number(salario_5 != null ? salario_5.toString() : 0)).reduce((sum, i) => sum + i, 0);

    const autoCompleteSelectedOptionGM = useMemo(() => {
        if (!selectedIdCompleteGM) return null;

        const selectedOption = opcoesAutoCompleteUsuarioGM.find(opcao => opcao.codigo === selectedIdCompleteGM);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteGM, opcoesAutoCompleteUsuarioGM]);



    const carregaPosicao = (posicao_1: string, posicao_2: string, posicao_3: string) => {

        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>

        return imgs
    }

    const handleRedirectDetalhesJogador = (codigoJogador: number, codigoFranquia: number) => {
        let crypt = UtilidadeService.crypt(`F|${codigoJogador.toString()}|${codigoFranquia}`);
        navigate(`/liga/jogadores/detalhe/${crypt}`);
    }

    const handleShowSwapProtecao = (dados: IDadosResumoPicksAno) => {

        let swap = dados.swap && !dados.protecao ? `${dados.resumo_Swap} `
            : !dados.swap && dados.protecao ? `${dados.inicio_Protecao} - ${dados.fim_Protecao} - ${dados.resumo_Protecao}`
                : `${dados.resumo_Swap}  - (${dados.inicio_Protecao} - ${dados.fim_Protecao}) ${dados.resumo_Protecao}`;
        setIsLoading(false);
        setShowModalMensagem(true);
        setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "info",
            mensagem: `${swap}`,
            display: "none",
            titulo: `RESUMO ${dados.swap && !dados.protecao ? "SWAP" : !dados.swap && dados.protecao ? "PROTEGIDA" : "SWAP PROTEGIDA"}`
        });
    }


    return (
        <LayoutBaseDePagina
            titulo={`Listagem de franquias - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                textoDaBusca={busca}
                aoClicarBotaoNovo={() => navigate('/liga/franquias')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="column" padding={1} spacing={1}>
                    <Grid container size={{ xs: 12, sm: 12 }} >
                        <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }} >
                            <TableContainer component={Paper} variant="outlined" sx={{ m: 0, width: "auto", marginRight: 1 }}>
                                <Table sx={{ border: "none" }}>
                                    <TableHead sx={{ border: "none" }}>
                                        <TableRow>
                                            <StyledTableCell align="center">FRANQUIAS</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ border: "none" }}>
                                        {rowsFranquias.sort((a, b) => a.nome > b.nome ? 1 : -1).map((row, i) => (
                                            <StyledTableRow key={`${row.codigo}_${i}`} sx={{ cursor: "pointer" }} >
                                                <StyledTableCell onClick={() => handleSelecionaJogadores(row.codigo)}>
                                                    <Grid container>
                                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                                            <Grid size={{ xs: 3, sm: 3 }} >
                                                                <img src={row.caminho_Logo != null ? row.caminho_Logo : "../../semimagemescudo.png"} alt={row.nome} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                                            </Grid>
                                                            <Grid container size={{ xs: 9, sm: 9 }}>
                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                    <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", fontWeight: 600 }} >{row.nome === null ? "Franquia " + i : row.nome}</Typography>
                                                                </Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                    <Typography variant='body2' style={{ fontSize: UtilidadeService.isMobile() ? 11 : "auto", fontWeight: 600 }}>{row.nome_Usuario}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12, md: 9, lg: 9 }} sx={{ width: "100%" }} key="dadosFranquia" display={showDadosFranquia ? "block" : "none"}  >
                            {!removeLoading && <Loading />}
                            <Grid container size={{ xs: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" >
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <Grid size={{ xs: 12, sm: 12 }} display="flex" spacing={1} justifyContent="center" paddingBottom={UtilidadeService.isMobile() ? 1 : 2} >
                                        <img src={showImagemFranquia} alt="SrcImagem" width={UtilidadeService.isMobile() ? 90 : 180} height={UtilidadeService.isMobile() ? 90 : 180} />
                                        {errors.showImagemFranquia && <span style={{ fontSize: "13px", color: "red" }}>{errors.showImagemFranquia}</span>}
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 6, sm: 5 }} >
                                    <Grid size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{nome_Franquia !== null ? "Franquia: " + nome_Franquia : "Franquia"}</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>{nome_Usuario !== null ? "GM: " + nome_Usuario : "GM: - "}</Typography>
                                    </Grid>
                                    {!UtilidadeService.isMobile() && usuarioComissario && (
                                        <>
                                            {!showCampoEdicaoGm ? (
                                                <Grid direction="row" size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={UtilidadeService.isMobile() ? 1 : 2} display="flex" justifyContent="center"  >
                                                    <Button
                                                        color="secondary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => handleAlterarGMFranquia(true)}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Alterar GM
                                                    </Button>
                                                </Grid>
                                            ) :
                                                <>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" >
                                                        <Grid size={{ xs: 12, sm: 11 }} alignItems="start">
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteUsuarioGM}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOptionGM}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => setSelectedIdCompleteGM(newValue?.codigo)}
                                                                popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Usuário"
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" >
                                                        <Grid size={{ xs: 12, sm: 11 }} >
                                                            <FormControl>
                                                                <FormControlLabel
                                                                    control={<MuiCheckBox
                                                                        name="chkSerGM"
                                                                        checked={chkSerComissario}
                                                                        onChange={e => {
                                                                            setChkSerComissario(e.target.checked);
                                                                        }}
                                                                    />}
                                                                    label="Comissário?"
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" >
                                                        <Grid size={{ xs: 12, sm: 5 }} spacing={2} padding={1} >
                                                            <Button
                                                                color="error"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={() => handleAlterarGMFranquia(false)}
                                                                startIcon={<Icon>cancel</Icon>}
                                                            >
                                                                Cancelar
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 5 }} spacing={2} padding={1}  >
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={handleSalvarGMFranquia}
                                                                startIcon={<Icon>save</Icon>}
                                                            >
                                                                Salvar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            }
                                        </>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }} >
                                    <Grid direction="row" size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={1}>
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 19, fontWeight: 600 }} sx={{ color: parseFloat(valor_CAP.toString()) < 0 ? "red" : theme.palette.common.white }}  >{`CAP: R$${moedaRealLocaleValue(valor_CAP)}`}</Typography>
                                    </Grid>
                                    <Grid direction="row" size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={1}>
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 19, fontWeight: 600, color: "#0288d1" }}>{`DRAFT: R$${moedaRealLocaleValue(valor_Draft)}`}</Typography>
                                    </Grid>
                                    <Grid direction="row" size={{ xs: 12, sm: 12 }} spacing={2} paddingBottom={1}>
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 19, fontWeight: 600 }}>{`SLOTS: ${qtd_Slots !== "" ? qtd_Slots : 0}`}</Typography>
                                    </Grid>
                                    {showTitulos && !UtilidadeService.isMobile() ?
                                        (
                                            <Grid size={{ xs: 12, sm: 12 }} spacing={1} direction="row">
                                                <Grid size={{ xs: 12, sm: 4 }} spacing={2}>
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 19, }}>TÍTULOS:</Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 8 }} spacing={2} >
                                                    <Grid key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                        {titulosDivisao.length > 0 && (titulosDivisao.map(div => (
                                                            <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }}>
                                                                <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                    <CardActionArea >
                                                                        <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                                                            <CardMedia
                                                                                component="img"
                                                                                alt="Divisão"
                                                                                height="35"
                                                                                image={imagemTrofelDivisao}
                                                                                key={div.codigo}
                                                                                sx={{ width: "30px" }}
                                                                            />
                                                                        </Tooltip>
                                                                    </CardActionArea>
                                                                </Card>
                                                            </Grid>
                                                        )))
                                                            // : <Grid  size={{xs:12, sm:12}} textAlign="center" >
                                                            //     <Typography variant="h6">Nenhum título de divisão</Typography>
                                                            //     <hr />
                                                            // </Grid>
                                                        }
                                                    </Grid>
                                                    <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                        {titulosConferencia.length > 0 && (titulosConferencia.map(conf => (
                                                            <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }} >
                                                                <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                    <CardActionArea>
                                                                        <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                                                            <CardMedia
                                                                                component="img"
                                                                                alt="Conferência"
                                                                                height="35"
                                                                                image={imagemTrofelConferencia}
                                                                                key={conf.codigo}
                                                                                sx={{ width: "30px" }}
                                                                            />
                                                                        </Tooltip>
                                                                    </CardActionArea>
                                                                </Card>
                                                            </Grid>
                                                        )))
                                                            // : <Grid  size={{xs:12, sm:12}} textAlign="center" >
                                                            //     <Typography variant="h6">Nenhum título de conferência</Typography>
                                                            //     <hr />
                                                            // </Grid>
                                                        }
                                                    </Grid>
                                                    <Grid container key="titulosL" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                        {titulosLiga.length > 0 && (titulosLiga.map(lig => (
                                                            <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }}>
                                                                <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                    <CardActionArea>
                                                                        <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                                                            <CardMedia
                                                                                component="img"
                                                                                alt="Liga"
                                                                                height="35"
                                                                                image={imagemTrofelLiga}
                                                                                key={lig.codigo}
                                                                                sx={{ width: "30px" }}
                                                                            />
                                                                        </Tooltip>
                                                                    </CardActionArea>
                                                                </Card>
                                                            </Grid>
                                                        )))
                                                        }
                                                    </Grid>
                                                    <Grid container key="titulosP" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                        {
                                                            titulosCopinha.length > 0 && (titulosCopinha.map(cop => (
                                                                <Grid key={cop.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", marginRight: "4px" }}>
                                                                    <Card key={cop.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                        <CardActionArea>
                                                                            <Tooltip title={`Copinha ${lstTemporadas.find(f => f.codigo === cop.codigo_Temporada)?.label}`}>
                                                                                <CardMedia
                                                                                    component="img"
                                                                                    alt="Copinha"
                                                                                    height="45"
                                                                                    image={imagemTrofelCopinha}
                                                                                    key={cop.codigo}
                                                                                    sx={{ width: "25px" }}
                                                                                />
                                                                            </Tooltip>
                                                                        </CardActionArea>
                                                                    </Card>
                                                                </Grid>
                                                            )))
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) 
                                        : 
                                        (<Grid container size={{ xs: 12, sm: 12 }} spacing={1} direction="row">
                                            <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20, fontWeight: 600 }}>TÍTULOS:</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 9 }} spacing={2} >
                                                <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                    {titulosDivisao.length > 0 && (titulosDivisao.map(div => (
                                                        <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }}>
                                                            <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                <CardActionArea>
                                                                    <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                                                        <CardMedia
                                                                            component="img"
                                                                            alt="Divisão"
                                                                            height="20"
                                                                            image={imagemTrofelDivisao}
                                                                            key={div.codigo}
                                                                            sx={{ padding: 0 }}
                                                                        />
                                                                    </Tooltip>
                                                                </CardActionArea>
                                                            </Card>
                                                            <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label.split("-")[0]}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    )))
                                                    }
                                                </Grid>
                                                <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                    {titulosConferencia.length > 0 && (titulosConferencia.map(conf => (
                                                        <Grid key={conf.codigo} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }} >
                                                            <Card key={conf.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                <CardActionArea>
                                                                    <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                                                        <CardMedia
                                                                            component="img"
                                                                            alt="Conferência"
                                                                            height="20"
                                                                            image={imagemTrofelConferencia}
                                                                            key={conf.codigo}
                                                                            sx={{ width: "20px", padding: 0 }}
                                                                        />
                                                                    </Tooltip>
                                                                </CardActionArea>
                                                            </Card>
                                                            <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label.split("-")[0]}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    )))
                                                    }
                                                </Grid>

                                                <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                    {titulosLiga !== null && titulosLiga.length > 0 && (titulosLiga.map(lig => (
                                                        <Grid key={lig.codigo} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%", marginRight: "6px" }}>
                                                            <Card key={lig.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                <CardActionArea>
                                                                    <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                                                        <CardMedia
                                                                            component="img"
                                                                            alt="Liga"
                                                                            height="20"
                                                                            image={imagemTrofelLiga}
                                                                            key={lig.codigo}
                                                                        // sx={{ width: "auto" }}
                                                                        />
                                                                    </Tooltip>
                                                                </CardActionArea>
                                                            </Card>
                                                            <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label.split("-")[0]}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    )))
                                                    }
                                                </Grid>

                                                <Grid container key="titulosP" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                                                    {
                                                        titulosCopinha.length > 0 && (titulosCopinha.map(cop => (
                                                            <Grid key={cop.codigo} size={{ xs: 1, sm: 1, md: 1 }} textAlign="center" style={{ maxWidth: "82%", marginRight: "4px" }}>
                                                                <Card key={cop.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                                                    <CardActionArea>
                                                                        <Tooltip title={`Copinha ${lstTemporadas.find(f => f.codigo === cop.codigo_Temporada)?.label}`}>
                                                                            <CardMedia
                                                                                component="img"
                                                                                alt="Copinha"
                                                                                height="45"
                                                                                image={imagemTrofelCopinha}
                                                                                key={cop.codigo}
                                                                                sx={{ width: "25px" }}
                                                                            />
                                                                        </Tooltip>
                                                                    </CardActionArea>
                                                                </Card>
                                                                 <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === cop.codigo_Temporada)?.label.split("-")[0]}</Typography>
                                                            </Grid>
                                                            </Grid>
                                                        )))
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>)
                                    }
                                    <button style={{ backgroundColor: "transparent", border: "none", boxShadow: "none", outline: "none" }}
                                        ref={refTab}></button>
                                </Grid>
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                                <Grid size={{ xs: 12, sm: 12 }} direction="column" padding={1} >
                                    <Grid size={{ xs: 12, sm: 12 }} spacing={1}>
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <Grid size={{ xs: 12, sm: 6 }} display={"flex"} justifyContent="flex-start">
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}> Estatísticas Jogadores</Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6 }} display={"flex"} justifyContent="flex-end">
                                                <DonwloadDadosFranquia nomeArquivo={`Franquia_${nome_Franquia}`} codigoFranquia={Number(codigoSelecionada)} />
                                            </Grid>
                                            <Grid size={{ xs: 12 }}>
                                                <hr />
                                            </Grid>

                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }}  >
                                            <TableContainer component={Paper} variant="outlined">
                                                <Table >
                                                    <TableHead >
                                                        <TableRow>
                                                            <StyledTableCell align="center">FOTO</StyledTableCell>
                                                            <StyledTableCell align="left">NOME</StyledTableCell>
                                                            <StyledTableCell align="center" style={{ minWidth: UtilidadeService.isMobile() ? "60px" : "75px" }}>POSIÇÃO</StyledTableCell>
                                                            <StyledTableCell align="right" style={{ minWidth: "90px" }}>{ano1}</StyledTableCell>
                                                            <StyledTableCell align="right" style={{ minWidth: "90px" }}>{ano2}</StyledTableCell>
                                                            <StyledTableCell align="right" style={{ minWidth: "90px" }}>{ano3}</StyledTableCell>
                                                            <StyledTableCell align="right" style={{ minWidth: "90px" }}>{ano4}</StyledTableCell>
                                                            <StyledTableCell align="right" style={{ minWidth: "90px" }}>{ano5}</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {estatisticasRows.slice(0, 25).map(row => (
                                                            <StyledTableRow key={row.codigo_Jogador}  >
                                                                <StyledTableCell align="center">
                                                                    <img src={row.foto_Jogador} alt={row.nome_Jogador}
                                                                        width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40}
                                                                        style={{ borderRadius: "20%" }}
                                                                        onError={({ currentTarget }) => {
                                                                            currentTarget.onerror = null;
                                                                            currentTarget.src = "../../../../semimagem.png";
                                                                            currentTarget.style.borderRadius = "50%";
                                                                            currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                            currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                        }} />
                                                                </StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : "auto" }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)} >{row.nome_Jogador}
                                                                    <span style={{ color: "#ED59BC" }}>
                                                                        {
                                                                            row.restrito === true && row.draftado === false ? " ®" :
                                                                                row.restrito === false && row.draftado === true ? <span style={{ color: "#59cbed" }}>&nbsp;Ð</span> :
                                                                                    row.restrito === true && row.draftado === true ? <><span style={{ color: "#ED59BC" }}>&nbsp;®</span> <span style={{ color: "#59cbed" }}>&nbsp;Ð</span></> : ""
                                                                        }
                                                                    </span>
                                                                </StyledTableCell>
                                                                <StyledTableCell style={{ textAlign: "center", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : "auto" }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)} >{carregaPosicao(row.posicao_1, row.posicao_2, row.posicao_3)}</StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", paddingLeft: "10px", textAlign: row.salario_1 === null ? "center" : "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : TipoSalario.find(f => f.codigo === row.tipo_Salario_1)?.color }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)}>{row.salario_1 === null ? "-" : moedaRealLocaleValue(row.salario_1)}</StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", paddingLeft: "10px", textAlign: row.salario_2 === null ? "center" : "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_2 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_2)?.color }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)}>{row.salario_2 === null ? "-" : moedaRealLocaleValue(row.salario_2)}</StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", paddingLeft: "10px", textAlign: row.salario_3 === null ? "center" : "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_3 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_3)?.color }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)}>{row.salario_3 === null ? "-" : moedaRealLocaleValue(row.salario_3)}</StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", paddingLeft: "10px", textAlign: row.salario_4 === null ? "center" : "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_4 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_4)?.color }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)}>{row.salario_4 === null ? "-" : moedaRealLocaleValue(row.salario_4)}</StyledTableCell>
                                                                <StyledTableCell style={{ minWidth: "68px", paddingLeft: "10px", textAlign: row.salario_5 === null ? "center" : "end", cursor: "pointer", color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_5 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_5)?.color }} onClick={() => handleRedirectDetalhesJogador(row.codigo_Jogador, row.codigo_Franquia)}>{row.salario_5 === null ? "-" : moedaRealLocaleValue(row.salario_5)}</StyledTableCell>
                                                            </StyledTableRow >
                                                        ))}
                                                        <StyledTableRow>
                                                            <StyledTableCell align="right" colSpan={3} sx={{ cursor: "pointer" }} onClick={() => handleCarregarDadosMultas(estatisticasRows[0].codigo_Franquia)}>
                                                                MULTA
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ color: "red", textAlign: "end" }}>
                                                                {franquiaMultasAnualRows?.multa_Ano1 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano1) : "-"}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ color: "red", textAlign: "end" }}>
                                                                {franquiaMultasAnualRows?.multa_Ano2 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano2) : "-"}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ color: "red", textAlign: "end" }}>
                                                                {franquiaMultasAnualRows?.multa_Ano3 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano3) : "-"}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ color: "red", textAlign: "end" }}>
                                                                {franquiaMultasAnualRows?.multa_Ano4 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano4) : "-"}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ color: "red", textAlign: "end" }}>
                                                                {franquiaMultasAnualRows?.multa_Ano5 !== undefined ? moedaRealLocaleValue(franquiaMultasAnualRows?.multa_Ano5) : "-"}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                        <StyledTableRow>
                                                            <StyledTableCell align="right" colSpan={3}>
                                                                TOTAL
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ textAlign: "end" }}>
                                                                {moedaRealLocaleValue(somatorio1.toFixed(0))}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ textAlign: "end" }}>
                                                                {moedaRealLocaleValue(somatorio2.toFixed(0))}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ textAlign: "end" }}>
                                                                {moedaRealLocaleValue(somatorio3.toFixed(0))}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ textAlign: "end" }}>
                                                                {moedaRealLocaleValue(somatorio4.toFixed(0))}
                                                            </StyledTableCell>
                                                            <StyledTableCell sx={{ textAlign: "end" }}>
                                                                {moedaRealLocaleValue(somatorio5.toFixed(0))}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                        {UtilidadeService.isMobile() ? (
                                                            <StyledTableRow>
                                                                <StyledTableCell align="right" colSpan={3} sx={{ cursor: "pointer" }} onClick={() => handleCarregarDadosMultas(estatisticasRows[0].codigo_Franquia)}>
                                                                    PICKS CEL
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, wordWrap: "break-word", wordBreak: "break-word", minWidth: "90px", textAlign: "end" }}>
                                                                    {resumo_Picks_Ano1.length > 0 ? resumo_Picks_Ano1.map(m => (<Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, }}>
                                                                        {!m.protecao && !m.swap ? m.resumo
                                                                            : !m.protecao && m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo}</span> </Button>
                                                                                : m.protecao && !m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P) </span> </Button>
                                                                                    : <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P/S) </span> </Button>}

                                                                    </Typography>)) : "-"}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, wordWrap: "break-word", wordBreak: "break-word", minWidth: "90px", textAlign: "end" }}>
                                                                    {resumo_Picks_Ano2.length > 0 ? resumo_Picks_Ano2.map(m => (<Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, }}>
                                                                        {!m.protecao && !m.swap ? m.resumo
                                                                            : !m.protecao && m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo}</span> </Button>
                                                                                : m.protecao && !m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P) </span> </Button>
                                                                                    : <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P/S) </span> </Button>}

                                                                    </Typography>)) : "-"}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, wordWrap: "break-word", wordBreak: "break-word", minWidth: "90px", textAlign: "end" }}>
                                                                    {resumo_Picks_Ano3.length > 0 ? resumo_Picks_Ano3.map(m => (<Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, }}>
                                                                        {!m.protecao && !m.swap ? m.resumo
                                                                            : !m.protecao && m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo}</span> </Button>
                                                                                : m.protecao && !m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P) </span> </Button>
                                                                                    : <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P/S) </span> </Button>}

                                                                    </Typography>)) : "-"}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, wordWrap: "break-word", wordBreak: "break-word", minWidth: "90px", textAlign: "end" }}>
                                                                    {resumo_Picks_Ano4.length > 0 ? resumo_Picks_Ano4.map(m => (<Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, }}>
                                                                        {!m.protecao && !m.swap ? m.resumo
                                                                            : !m.protecao && m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo}</span> </Button>
                                                                                : m.protecao && !m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P) </span> </Button>
                                                                                    : <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P/S) </span> </Button>}

                                                                    </Typography>)) : "-"}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 14, wordWrap: "break-word", wordBreak: "break-word", minWidth: "90px", textAlign: "end" }}>
                                                                    {resumo_Picks_Ano5.length > 0 ? resumo_Picks_Ano5.map(m => (<Typography variant="body2" sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 14, }}>
                                                                        {!m.protecao && !m.swap ? m.resumo
                                                                            : !m.protecao && m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo}</span> </Button>
                                                                                : m.protecao && !m.swap ? <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P) </span> </Button>
                                                                                    : <Button variant="outlined" sx={{ cursor: "pointer", fontSize: 11, padding: "0px", outline: "none", border: "none", ":hover": { outline: "none", border: "none" } }} onClick={(_) => handleShowSwapProtecao(m)}><span>{m.resumo} (P/S) </span> </Button>}

                                                                    </Typography>)) : "-"}
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        )

                                                            : (
                                                                <StyledTableRow>
                                                                    <StyledTableCell align="right" colSpan={3} sx={{ cursor: "pointer" }} onClick={() => handleCarregarDadosMultas(estatisticasRows[0].codigo_Franquia)}>
                                                                        PICKS PC
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "125px", textAlign: "end" }}>
                                                                        {resumo_Picks_Ano1.length > 0 ? resumo_Picks_Ano1.map(m => (<Typography variant="body2">
                                                                            {!m.protecao && !m.swap ? m.resumo
                                                                                : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={m.resumo_Swap}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo}</span></Tooltip>
                                                                                    : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo_Protecao} (P)</span></Tooltip>
                                                                                        : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}
                                                                        </Typography>)) : "-"}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "125px", textAlign: "end" }}>
                                                                        {resumo_Picks_Ano2.length > 0 ? resumo_Picks_Ano2.map(m => (<Typography variant="body2">
                                                                            {!m.protecao && !m.swap ? m.resumo
                                                                                : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={m.resumo_Swap}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo}</span></Tooltip>
                                                                                    : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo_Protecao} (P)</span></Tooltip>
                                                                                        : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}
                                                                        </Typography>)) : "-"}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "125px", textAlign: "end" }}>
                                                                        {resumo_Picks_Ano3.length > 0 ? resumo_Picks_Ano3.map(m => (<Typography variant="body2">
                                                                            {!m.protecao && !m.swap ? m.resumo
                                                                                : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={m.resumo_Swap}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo}</span></Tooltip>
                                                                                    : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo_Protecao} (P)</span></Tooltip>
                                                                                        : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}

                                                                        </Typography>)) : "-"}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "125px", textAlign: "end" }}>
                                                                        {resumo_Picks_Ano4.length > 0 ? resumo_Picks_Ano4.map(m => (<Typography variant="body2">
                                                                            {!m.protecao && !m.swap ? m.resumo
                                                                                : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={m.resumo_Swap}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo}</span></Tooltip>
                                                                                    : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo_Protecao} (P)</span></Tooltip>
                                                                                        : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}
                                                                        </Typography>)) : "-"}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ wordWrap: "break-word", wordBreak: "break-word", minWidth: "125px", textAlign: "end" }}>
                                                                        {resumo_Picks_Ano5.length > 0 ? resumo_Picks_Ano5.map(m => (<Typography variant="body2">
                                                                            {!m.protecao && !m.swap ? m.resumo
                                                                                : !m.protecao && m.swap ? <Tooltip style={{ cursor: "pointer" }} title={m.resumo_Swap}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo}</span></Tooltip>
                                                                                    : m.protecao && !m.swap ? <Tooltip style={{ cursor: "pointer" }} title={`(${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao}`}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo_Protecao} (P)</span></Tooltip>
                                                                                        : <Tooltip style={{ cursor: "pointer" }} title={`${m.resumo_Swap} - (${m.inicio_Protecao} - ${m.fim_Protecao}) ${m.resumo_Protecao} `}><span style={{ color: "#fbc02d", cursor: "pointer" }}>{m.resumo} (P/S)</span></Tooltip>}
                                                                        </Typography>)) : "-"}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" direction="row" padding="10px" spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center" >
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "white", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Normal </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center">
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#28a1db", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Player Option </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center">
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#d56413", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Team Option </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center" >
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#36ae2c", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}>Qualifying Offer </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center">
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "#e51a8a", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}> Two-Way Contract</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }} display="flex" alignSelf="center">
                                        <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: "red", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                                        <Typography sx={{ padding: "2px", fontSize: "11px", fontWeight: "bold" }}> Contundido/Fora NBA </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    );
};